export default __webpack_public_path__ + "static/media/rocknversebig.dfb723ef.png";